import { Directive, HostListener, ElementRef, Renderer2 } from '@angular/core';

@Directive({
    selector: '[appNumberWithDecimalPointOnly]',
    standalone: false
})
export class NumberWithDecimalPointOnlyDirective {
  private errorMsgEl: HTMLElement | null = null;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  private showError(message: string) {
    if (!this.errorMsgEl) {
      this.errorMsgEl = this.renderer.createElement('div');
      this.renderer.addClass(this.errorMsgEl, 'text-danger');
      this.renderer.setStyle(this.errorMsgEl, 'fontSize', '12px');
      this.renderer.setStyle(this.errorMsgEl, 'marginTop', '4px');
      this.renderer.appendChild(this.el.nativeElement.parentNode, this.errorMsgEl);
    }
    this.renderer.setProperty(this.errorMsgEl, 'textContent', message);
  }

  private hideError() {
    if (this.errorMsgEl) {
      this.renderer.removeChild(this.el.nativeElement.parentNode, this.errorMsgEl);
      this.errorMsgEl = null;
    }
  }

  @HostListener('input', ['$event'])
  onInput(event: Event) {
    const inputField = this.el.nativeElement as HTMLInputElement;
    let val = inputField.value.trim();

    if (/[^0-9.]/.test(val)) {
      this.showError('Input must not include spaces or letters.');
      this.renderer.setProperty(inputField, 'value', '');
    } else {
      this.hideError();

      const parts = val.split('.');
      if (parts.length > 2) {
        this.showError('Input must not contain more than one decimal point.');
        val='';
      }

      else if (parts[0].length > 1) {
        this.hideError();
        parts[0] = parts[0].replace(/^0+(?!$)/, '');
        val = parts.join('.');
      }

      this.renderer.setProperty(inputField, 'value', val);
    }
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (event.key === ' ') {
      event.preventDefault();
      return;
    }

    const allowedKeys = ['Backspace', 'Delete', 'Escape', 'Enter', 'Home', 'End', 'ArrowLeft', 'ArrowRight', 'Tab'];

    if (
      allowedKeys.includes(event.key) ||
      (['a', 'c', 'v', 'x'].includes(event.key) && (event.ctrlKey || event.metaKey))
    ) {
      return;
    }

    if (event.key === '.') {
      const inputField = event.target as HTMLInputElement;
      if (inputField.value.includes('.')) {
        event.preventDefault();
      }
      return;
    }

    if (isNaN(Number(event.key))) {
      event.preventDefault();
    }
  }
}
